export default __webpack_public_path__ + "static/media/mc_eject_tube.105fc461.svg";